import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import menuReducer from './reducers/menuReducer'
import settingsReducer from './reducers/settingsReducer'
import { persistStore, persistReducer } from 'redux-persist'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import storage from 'redux-persist/lib/storage'
import markingReducer from './reducers/markingReducer'

import analyticsReducer from './reducers/analytics.reducer'
import alertReducer from './reducers/alert.reducer'
import appsReducer from './reducers/app.reducer'
import assessmentReducer from './reducers/assessment.reducer'
import classReducer from './reducers/class.reducer'
import classesReducer from './reducers/class-marking.reducer'
import curriculumReducer from './reducers/curriculum.reducer'
import datatableReducer from './reducers/datatable.reducer'
import dateReducer from './reducers/date.reducer'
import developmentalRubricReducer from './reducers/developmental-rubrics.reducer'
import filterReducer from './reducers/filter.reducer'
import learningcontinuumReducer from './reducers/learning-continuum.reducer'
import roleReducer from './reducers/role.reducer'
import periodicalReportReducer from './reducers/periodical-report.reducer'
import sessionReducer from './reducers/session.reducer'
import tenantReducer from './reducers/tenant.reducer'
import subjectReducer from './reducers/subjects.reducer'
import userReducer from './reducers/user.reducer'
import feedReducer from './reducers/feed.reducer'

//Data Entry
import dataEntryAssessmentTemplatesReducer from './reducers/dataEntryAssessmentTemplatesReducer'
import dataEntrySurveyReducer from './reducers/dataEntrySurveyReducer'
import dataEntrySurveyTemplatesReducer from './reducers/dataEntrySurveyTemplatesReducer'
import dataEntrySurveyBuilderReducer from './reducers/dataEntrySurveyBuilderReducer'
import dataEntrySurveyPreviewReducer from './reducers/dataEntrySurveyPreviewReducer'
import dataEntryTemplateGeneratorReducer from './reducers/dataEntryTemplateGeneratorReducer'
import dataEntryAssessmentReducer from './reducers/dataEntryAssessmentReducer'
import dataEntryAssessmentBuilderReducer from './reducers/dataEntryAssessmentBuilderReducer'
import dataEntryAssessmentMarkingReducer from './reducers/dataEntryAssessmentMarkingReducer'
import journalCategoriesReducer from './reducers/journalCategoriesReducer'
import journalTemplatesReducer from './reducers/journalTemplatesReducer'
import journalEntriesReducer from './reducers/journalEntriesReducer'
import journalZonesReducer from './reducers/journalZonesReducer'
import journalSeveritiesReducer from './reducers/journalSeveritiesReducer'
import journalTypesReducer from './reducers/journalTypesReducer'
import dataEntryMySurveysReducer from './reducers/dataEntryMySurveysReducer'
import dataEntryFillASurveyReducer from './reducers/dataEntryFillASurveyReducer'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: [
    'audit',
    'analytics',
    'lc',
    'dr',
    'roles',
    'app',
    'analytics',
    'license',
    'class',
    'classMarking',
    'marking',
    'college',
    'user',
    'datatable',
    'periodicalReport',
    'tenant',
    'filter',
    'curriculum',
    'assessment',
    'subject',
    'alert',
    'dataEntrySurveyPreview',
    'dataEntryAssessmentTemplates',
    'dataEntrySurvey',
    'dataEntryMySurveys',
    'dataEntrySurveyTemplates',
    'dataEntryAssessmentBuilder',
    'feed'
  ],
  //whitelist: ['alert', 'auth', 'settings', 'class', 'student', 'teacher', 'generator', 'user', 'menu', 'roles', 'college'],
  stateReconciler: hardSet
}

const appReducer = combineReducers({
  alert: alertReducer,

  analytics: analyticsReducer,
  app: appsReducer,
  assessment: assessmentReducer,

  class: classReducer,
  classMarking: classesReducer,
  curriculum: curriculumReducer,

  datatable: datatableReducer,
  date: dateReducer,
  dr: developmentalRubricReducer,

  filter: filterReducer,
  feed: feedReducer,
  lc: learningcontinuumReducer,

  menu: menuReducer,
  marking: markingReducer,

  roles: roleReducer,

  session: sessionReducer,
  settings: settingsReducer,
  periodicalReport: periodicalReportReducer,
  subject: subjectReducer,

  tenant: tenantReducer,

  user: userReducer,

  dataEntryAssessmentTemplates: dataEntryAssessmentTemplatesReducer,
  dataEntrySurvey: dataEntrySurveyReducer,
  dataEntryMySurveys: dataEntryMySurveysReducer,
  dataEntrySurveyTemplates: dataEntrySurveyTemplatesReducer,
  dataEntrySurveyBuilder: dataEntrySurveyBuilderReducer,
  dataEntrySurveyPreview: dataEntrySurveyPreviewReducer,
  dataEntryFillASurvey: dataEntryFillASurveyReducer,
  dataEntrytemplateGenerator: dataEntryTemplateGeneratorReducer,
  dataEntryAssessment: dataEntryAssessmentReducer,
  dataEntryAssessmentMarking: dataEntryAssessmentMarkingReducer,
  dataEntryAssessmentBuilder: dataEntryAssessmentBuilderReducer,
  journalCategories: journalCategoriesReducer,
  journalTemplates: journalTemplatesReducer,
  journalEntries: journalEntriesReducer,
  journalZones: journalZonesReducer,
  journalSeverities: journalSeveritiesReducer,
  journalTypes: journalTypesReducer
})

const persistedReducer = persistReducer(persistConfig, appReducer)
export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)
